import {
  Component,
  Inject,
  OnInit,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { KeyboardNum } from "../keyboard-num";
import * as _ from "lodash";

@Component({
  selector: "app-keyboard-num",
  templateUrl: "./keyboard-num.component.html",
  styleUrls: ["./keyboard-num.component.scss"],
  standalone: false,
})
export class KeyboardNumComponent implements OnInit {
  public keyboard: KeyboardNum = new KeyboardNum();
  public selectionStart: number = 0;
  public selectionEnd: number = 0;
  public elementValue: string;
  @ViewChild("keyValue") inputValue: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<KeyboardNumComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.elementValue = _.cloneDeep(this.data.value);
    if (this.elementValue != null) {
      this.selectionStart = 0;
      this.selectionEnd = this.elementValue.length;
    }

    this.dialogRef.updateSize("40%", "80%");

    let textScreen: HTMLInputElement = document.getElementById(
      "textScreen",
    ) as HTMLInputElement;
    //Si al final es ús exclusiu del screeb keyboard el listener de keyup es pot eliminar
    textScreen.addEventListener("keyup", (e) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      ) {
        this.selectionStart =
          e.target["selectionStart"] != null
            ? (e.target["selectionStart"] as number)
            : 0;
        this.selectionEnd =
          e.target["selectionEnd"] != null
            ? (e.target["selectionEnd"] as number)
            : 0;
      }
    });
    textScreen.addEventListener("click", (e) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      ) {
        this.selectionStart =
          e.target["selectionStart"] != null
            ? (e.target["selectionStart"] as number)
            : 0;
        this.selectionEnd =
          e.target["selectionEnd"] != null
            ? (e.target["selectionEnd"] as number)
            : 0;
      }
    });
    textScreen.addEventListener("change", (e) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      ) {
        this.selectionStart =
          e.target["selectionStart"] != null
            ? (e.target["selectionStart"] as number)
            : 0;
        this.selectionEnd =
          e.target["selectionEnd"] != null
            ? (e.target["selectionEnd"] as number)
            : 0;
      }
    });
  }

  triggerEvents() {
    this.data.dispatchEvent(new KeyboardEvent("input"));
    this.data.dispatchEvent(new KeyboardEvent("change"));
    this.data.dispatchEvent(new KeyboardEvent("keydown"));
  }

  triggerIntro() {
    var keyEvent = new KeyboardEvent("keydown", {
      bubbles: true,
      cancelable: true,
      key: "Enter",
      code: "Enter",
    });
    this.data.dispatchEvent(keyEvent);
  }

  getLength(start, end) {
    return end - start;
  }

  addChar(char) {
    this.focus();
    let start = this.selectionStart;
    if (char == "+/-") {
      if (this.elementValue != null && this.elementValue != "0") {
        if (this.elementValue.includes("-")) {
          this.elementValue = this.elementValue.substring(1);
          this.selectionEnd = start;
        } else {
          this.elementValue = "-" + this.elementValue;
          this.selectionEnd = start + 1;
        }
      }
    } else if (char == ".") {
      let inc = this.elementValue.includes(".");
      if (start == 0 && this.selectionEnd == 1 && this.elementValue == "0") {
        start += 1;
      } else if (this.elementValue == "") {
        this.elementValue = "0";
        start += 1;
      }
      this.elementValue = this.elementValue + (!inc ? "." : "");
      this.selectionEnd = start + (inc ? 1 : 0);
    } else {
      if (this.selectionEnd > start) {
        let splited = this.elementValue.split("");
        let length = this.getLength(start, this.selectionEnd);
        splited.splice(start, length, char);
        this.elementValue = splited.join("");
      } else {
        this.elementValue =
          this.elementValue.slice(0, start) +
          char +
          this.elementValue.slice(start);
      }
      this.selectionEnd = start + 1;
    }
    this.selectionStart = start + 1;
  }

  onCe() {
    this.focus();
    this.elementValue = "";
  }

  onEnterClick(): void {
    try {
      // let result = eval(this.elementValue.replace(/^0+/, ""));
      let result = this.elementValue;
      this.data.value = result;
      this.triggerEvents();
      this.triggerIntro();
      this.dialogRef.close(this.data);
    } catch (error) {
      this.elementValue = "Syntax error";
    }
  }

  focus() {
    this.inputValue.nativeElement.focus();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
